<template>
    <div>
        <el-dialog
            title="风险测评结果"
            :visible.sync="dialogVisible"
            width="550px"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            v-on:close="handleCancel"
        >
            <div style="display: flex">
                <i class="el-icon-info warn-blue"></i>
                <div>
                    <div class="dialog-content">
                        <p>
                            测评结果：您的风险承受能力为 【{{
                                getRiskLevelText
                            }}】，根据我公司的适当性管理规则，与您风险承受能力等级相匹配的产品为：
                        </p>
                        <p
                            style="
                                margin: 20px 0;
                                color: var(--color-text-primary);
                                font-weight: bold;
                            "
                        >
                            {{ getMatchedProduct }}；
                        </p>
                    </div>
                    <div v-if="agreementList.length > 0" class="agreement-section">
                        <div class="checkbox-wrapper">
                            <el-checkbox v-model="isAgree" class="agreement-checkbox"></el-checkbox>
                            <div class="text-wrapper">
                                <span class="agree-text">我已阅读并同意:</span>
                                <div class="agreement-list">
                                    <span
                                        v-for="(item, index) in agreementList"
                                        :key="index"
                                        class="agreement-item"
                                    >
                                        <span
                                            class="agreement-link"
                                            v-on:click="handleAgreementDetail(index)"
                                        >
                                            《{{ item.title }}》
                                        </span>
                                        <span
                                            v-if="index < agreementList.length - 1"
                                            class="separator"
                                        >
                                            {{ index === agreementList.length - 2 ? "及" : "、" }}
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <p v-show="showErrorTip" class="error-tip">
                            请先阅读并同意相关协议后再确认
                        </p>
                    </div>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button class="btn" v-on:click="handleCancel">取消</el-button>
                <el-button class="btn" type="primary" v-on:click="handleConfirm">确认</el-button>
            </span>
        </el-dialog>
        <pdf-popup
            base64
            :visible="pdfVisible"
            :need-time="false"
            :read-file-info-list="currentFileInfoList"
            v-on:close="pdfVisible = false"
        ></pdf-popup>
    </div>
</template>

<script>
import { sceneEnum } from "@/util/util_jfit";
import PdfPopup from "@/components/util/pdfPopup.vue";

export default {
    name: "RiskConfirmDialog",
    components: { PdfPopup },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        riskLevel: {
            type: String,
            required: true
        },
        lowriskflag: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            dialogVisible: false,
            isAgree: false,
            showErrorTip: false,
            lowriskCanBuy: false,
            pdfVisible: false,
            currentFileInfoList: [],
            agreementList: []
        };
    },
    computed: {
        getRiskLevelText() {
            if (this.riskLevel === "0" || this.lowriskflag === "1") {
                return "最低风险等级(C0)";
            }
            return this.$cache.getDict("100017", this.riskLevel, false) + `(C${this.riskLevel})`;
        },
        getMatchedProduct() {
            if (this.riskLevel === "0" || this.lowriskflag === "1") {
                return this.lowriskCanBuy
                    ? "低风险(R1)产品（不允许购买风险错配产品）"
                    : "禁止购买任意产品";
            }
            const productRisk = this.$cache.getDict("110143") || [];
            const matchedRisk = productRisk.filter((item) => item.subitem <= this.riskLevel);
            if (matchedRisk.length === 0) return "无匹配产品";
            const res = matchedRisk
                .map((item) => item.subitemname + `风险(R${item.subitem})产品`)
                .join(";");
            return res;
        }
    },
    watch: {
        visible(newVal) {
            this.dialogVisible = newVal;
        },
        isAgree(newVal) {
            if (newVal) this.showErrorTip = false;
        }
    },
    mounted() {
        this.lowriskCanBuy = this.$cache.getCompanyInfoParam("6000016") !== "1";
        this.queryFile();
    },
    methods: {
        queryFile() {
            this.$util
                .getProtocol(sceneEnum.riskConfirm)
                .then((res) => {
                    this.agreementList = Array.isArray(res) ? res : [];
                })
                .catch(() => {
                    this.agreementList = [];
                });
        },
        handleAgreementDetail(index) {
            this.currentFileInfoList = [this.agreementList[index]];
            this.pdfVisible = true;
        },
        handleCancel() {
            this.resetState();
            this.$emit("cancel");
        },
        handleConfirm() {
            if (this.agreementList.length > 0 && !this.isAgree) {
                this.showErrorTip = true;
                return;
            }
            this.resetState();
            this.$emit("confirm");
        },
        resetState() {
            this.dialogVisible = false;
            this.isAgree = false;
            this.showErrorTip = false;
        }
    }
};
</script>

<style scoped>
.dialog-content {
    color: var(--color-text-primary);
    display: inline-block;
    font-size: 14px;
    line-height: 22px;
}
.warn-blue {
    color: var(--color-primary);
    font-size: 18px;
    margin: 2px 4px 0 0;
}
.agreement-section {
    margin-bottom: 10px;
    line-height: 30px;
}
.checkbox-wrapper {
    display: flex;
    align-items: flex-start;
}
.agreement-checkbox {
    margin-right: 8px;
    margin-top: 1px;
}
.text-wrapper {
    flex: 1;
}
.agree-text {
    color: var(--color-text-primary);
    font-size: 14px;
    display: inline-block;
    vertical-align: top;
}
.agreement-list {
    display: inline-flex;
    vertical-align: top;
}
/* 协议项样式 */
.agreement-link {
    color: var(--color-primary);
    cursor: pointer;
    font-size: 14px;
    display: inline-block;
    line-height: 30px;
}
.error-tip {
    color: var(--color-warning);
    font-size: 12px;
    text-align: left;
    margin: 4px 0 0 30px;
    line-height: 1;
}
:deep(.el-dialog__header) {
    background: var(--color-divided);
}
:deep(.el-dialog__footer) {
    text-align: center;
}
.btn {
    width: 160px;
}
</style>
